import Blockly from 'blockly'
import 'blockly/python'

let blockJson = {
  type: 'machine_ifzero_ultrasonic',
  message0: '%{BKY_CUSTOM_MACHINE_IFZERO_ULTRASONIC}',
  args0: [
    {
      type: 'field_image',
      src: 'https://i.ibb.co/kByzBzq/ifkit.jpg',
      width: 30,
      height: 30,
      alt: '*'
    },
    {
      type: 'input_value',
      name: 'SONIC_ID',
      check: 'Number'
    },
    {
      type: 'input_value',
      name: 'TRIG_PIN',
      check: 'Number'
    },
    {
      type: 'input_value',
      name: 'ECHO_PIN',
      check: 'Number'
    },
    {
      type: 'field_dropdown',
      name: 'IS_FILTERED',
      options: [
        ['%{BKY_CUSTOM_MACHINE_IFZERO_ULTRASONIC_V_NORMAL}', 'False'],
        ['%{BKY_CUSTOM_MACHINE_IFZERO_ULTRASONIC_V_FILTERED}', 'True']
      ]
    }
  ],
  output: 'Number',
  style: 'sensor_blocks',
  tooltip: '%{BKY_CUSTOM_MACHINE_IFZERO_ULTRASONIC_TOOLTIP}',
  helpUrl: ''
}

Blockly.Blocks['machine_ifzero_ultrasonic'] = {
  init: function () {
    this.jsonInit(blockJson)
  }
}

Blockly.Python['machine_ifzero_ultrasonic'] = function (block) {
  if (!block.disabled)
    Blockly.Python.definitions_.import_ifzero = 'import ifzero'
  let id = Blockly.Python.valueToCode(
    block,
    'SONIC_ID',
    Blockly.Python.ORDER_ATOMIC
  )
  id = id ? id : 0
  let trigPin = Blockly.Python.valueToCode(
    block,
    'TRIG_PIN',
    Blockly.Python.ORDER_ATOMIC
  )
  trigPin = trigPin ? trigPin : 0
  let echoPin = Blockly.Python.valueToCode(
    block,
    'ECHO_PIN',
    Blockly.Python.ORDER_ATOMIC
  )
  echoPin = echoPin ? echoPin : 0
  let dropdownType = block.getFieldValue('IS_FILTERED')
  let code = `ifzero.ultrasonic(${id}, ${trigPin}, ${echoPin}, ${dropdownType})`
  return [code, Blockly.Python.ORDER_ATOMIC]
}
